import { Pagination } from './pagination';

export class Setting {
    id = 0;
    name = '';
    type = '';
    externalSource = false;
    data: any[] = [];
}

export class SettingResponse {
    message = '';
    pagination = new Pagination;
    setting = new Setting;
    settings: Setting[];
}
